module.exports = __webpack_public_path__ + "static/media/click.64815524.mp3";